<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" >
            <div class="modal-container" style="max-height:100vh;overflow-y:scroll;">

              <div class="modal-header">
                <slot name="header">
                  Update the fields which need change
                </slot>
              </div>

              <div class="modal-body">
                <slot name="body">
                  Change Author Display Name
                  <div class="input-box">
                    <input type="text" v-model="passedObject.displayName">
                  </div>
                  Change About author - Biographical information
                  <div class="input-box">
                    <input type="text" v-model="passedObject.aboutAuthor">
                  </div>
                  Change Author Tagline
                  <div class="input-box">
                    <input type="text" v-model="passedObject.authorTagline">
                  </div>
                  Change SEO Title for author page
                  <div class="input-box">
                    <input type="text" v-model="passedObject.authorSeoTitle">
                  </div>
                  Change SEO Description for author page
                  <div class="input-box">
                    <input type="text" v-model="passedObject.authorSeoDesc">
                  </div>
                  <div v-if="passedObject.customAvatar">
                    Current Author Image
                    <img :src="passedObject.customAvatar" style="width:50px;height:auto;">
                  </div>
                  <div v-else>The Author does not have custom image</div>
                  Upload new image to change author image
                  <ic-firebase-upload
                  path="images"
                  max-files="1"
                  :getFileName="getFileName"
                  :storage="storage"
                  @uploaded="onUploadedAuthorImage"
                  @upload="onUpload"
                  @delete="onDelete"
                 ></ic-firebase-upload>
                </slot>
              </div>

              <div class="modal-footer">
                <slot name="footer">
                  <button class="modal-default-button" @click="editAuthor">
                    UPDATE AUTHOR
                  </button>
                  <button class="modal-default-button cancel-delete-button" @click="closeTheModal">
                    CANCEL
                  </button>
                </slot>
              </div>
            </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from "vue";
import firebase from 'firebase';
import VueFirestore from "vue-firestore";
require("firebase/firestore");
Vue.use(VueFirestore);
var firestore;
import IcFirebaseUploader from "ic-firebase-uploader";
import "ic-firebase-uploader/dist/ic-firebase-uploader.min.css";
  export default {
    name: 'modal',
    components: {"ic-firebase-upload": IcFirebaseUploader},
    props: {
      passedObject: {
          type: Object
      }
    },
    firestore() {
      return {

      };
    },
    data: function() {
      firestore = firebase.firestore();
      return {
        storage: firebase.storage(),
      }
    },
    methods: {
      editAuthor() {
        if(!this.passedObject.authorSeoTitle){
          this.passedObject.authorSeoTitle = "";
        }

        if(!this.passedObject.authorSeoDesc){
          this.passedObject.authorSeoDesc = "";
        }

        if(!this.passedObject.customAvatar){
          this.passedObject.customAvatar = "";
        }
        firestore
          .collection("authors")
          .doc(this.passedObject.slug)
          .update({
            displayName: this.passedObject.displayName,
            aboutAuthor: this.passedObject.aboutAuthor,
            authorTagline: this.passedObject.authorTagline,
            authorSeoTitle: this.passedObject.authorSeoTitle,
            authorSeoDesc: this.passedObject.authorSeoDesc,
            customAvatar: this.passedObject.customAvatar
          });
        alert("User updated");
        this.$emit('update:modal');
    },
      closeTheModal() {
        this.$emit('update:modal');
     },
     onUpload: function(e) {
       e.doUpload();
     },
     onDelete: function(e) {
       e.doDelete();
     },
     getFileName: function(file) {
       return file.name + Math.floor(Math.random() * 1000);
     },
     onUploadedAuthorImage: function(e) {
       e.getDownloadURL().then(url => {
         this.passedObject.customAvatar = url;
       });
     }
   }
  }
</script>

<style>
.result em {
  background-color: #ccc;
  color:black;
}
.user-edit-screen .md-autocomplete .md-menu input {
  color: black !important;
  -webkit-text-fill-color: black !important;
}
.md-field.md-theme-default:after {
    background-color: rgba(140, 139, 139, 0.7) !important;
}
.md-field.md-theme-default .md-helper-text, .md-field.md-theme-default .md-count, .md-field.md-theme-default label {
    color: rgba(140, 139, 139, 0.7) !important;
}
</style>

<style scoped>

.flex-row {
  display:flex;
}
input {
  display:block;
}
.cancel-delete-button {
  background-color: #ff5252;
}
.modal-mask {
  overflow-y:scroll;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 550px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header{
  color:#000000;
  text-align:center;
}

.modal-body {
  margin: 20px 0;
  color:#000000;
}

.modal-default-button {
  float: right;
}
.modal-footer {
  padding:10px;
}
.modal-footer button {
  margin-right:10px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}


@media screen and (min-width: $responsive_breakpoint_min) {
  .scrolling-wrapper-flexbox {
    scroll-behavior: smooth;
    overflow-x: hidden;
  }
}
@media screen and (max-width: $responsive_breakpoint_max) {
  .scrolling-wrapper-flexbox {
    overflow-x: scroll;
  }
}
.scrolling-wrapper-flexbox {
    display: flex;
    flex-wrap: nowrap;

    overflow-x:scroll;
    -webkit-overflow-scrolling: touch;
}
input {
      width: 500px;
}
</style>



// WEBPACK FOOTER //
// ModalAuthoredit.vue?09f19c36